import 'photoswipe/dist/photoswipe.css'
import './/artwork-gallery.scss';

import { Gallery, Item } from 'react-photoswipe-gallery'

export function ArtworkGallery({list,withCaption}:{list:any;withCaption:boolean}){

    return(
        <div className='img-gallery'>
        <Gallery withCaption={withCaption} >
            {
                list.map((item:any,index:number)=>{

                    return (
                        <Item
                            key={index}
                            original={`/api/assets/${item.image.id}?key=original`}
                            thumbnail={`/api/assets/${item.image.id}?key=thumbnail`}
                            width={item.image.width}
                            height={item.image.height}
                            caption={item?.description}
                            >
                            {({ ref, open }) => (
                                <div>
                                <img ref={ref} onClick={open} src={`/api/assets/${item.image.id}?key=thumbnail`} title={item.label} className='item-thumbnail-gallery' />
                                </div>
                            )}
                        </Item>
                    )
            })}
        </Gallery>
        </div>
    )
}